import { writable } from "svelte/store";
const { subscribe, update } = writable({});
export const profileStore = {
    subscribe,
    capture: (key, val) => update((data) => {
        const currentStream = data[key] ?? [];
        const newStream = [...currentStream, val];
        if (newStream.length > 11) {
            newStream.shift();
        }
        return {
            ...data,
            [key]: newStream,
        };
    }),
};
